import script from "./inventoryLists.vue?vue&type=script&lang=ts&setup=true"
export * from "./inventoryLists.vue?vue&type=script&lang=ts&setup=true"

import "./inventoryLists.vue?vue&type=style&index=0&id=4d70bb3c&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d70bb3c"]])

export default __exports__